define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader'], function($, transit, modernizr, container, preloader) {

    var slider = function(id) {

        var publicVars = {
            btnInactive: 0
        };

        var privateVars = {
            name: 'carousel(' + id + ')',
            sliderCount: 0,
            originalSliderCount: 0,
            sliderSets: 0,
            slide: 0,
            sliderCurrentSet: 1,
            sliderCurrentItemFirst: 1,
            sliderCurrentItemLast: 2,
            sliderItemsMap: {},
            elemDecorateCallback: '',
            callbacks: [

            ],
            filterFlag: 0,
            originalSliderItemsMapHolder: {},

            touchStart: 0,
            touchDiff: 0,
            touchStartY: 0,
            touchDiffY: 0,

            slideStarted: false,
            endTrans: false,

            clickedHref: ''
        };


        var privateMethods = {
            prepareObj: function(options) {

                publicVars = container.performCopy(publicVars, options);

                preloader.init();

                privateMethods.bind();

                privateMethods.startup();


            },
            /*
             * preload images
             */
            preloadImages: function() {
                /*var sliderItems = $(publicVars.cssId.sliderItemCls);
                 
                 sliderItems.each(function(index) {
                 var imgSrc = container.getData(sliderItems[index], 'img.src');
                 
                 preloader.preloadSingleImage('system', imgSrc, function() {
                 });
                 });*/

                var currentFirst = privateVars.sliderCurrentItemFirst;

                for (var i = 0; i < 2 * publicVars.perSetItems; i++) {

                    if (privateVars.sliderItemsMap[(privateVars.sliderCurrentItemLast + i)]) {

                        var imgSrc = container.getData(privateVars.sliderItemsMap[(privateVars.sliderCurrentItemLast + i)].element[0], 'img.src');

                        $(publicVars.cssId.sliderItemBoxImgCls, privateVars.sliderItemsMap[(privateVars.sliderCurrentItemLast + i)].element).attr('src', imgSrc);

                        preloader.preloadSingleImage('system', imgSrc, function() {
                        });

                    }

                    if (currentFirst > 1) {
                        currentFirst = currentFirst - 1;
                    } else {
                        currentFirst = privateVars.sliderCount;
                    }

                    if (privateVars.sliderItemsMap[(currentFirst - 1)]) {

                        var imgSrc = container.getData(privateVars.sliderItemsMap[(currentFirst - 1)].element[0], 'img.src');

                        $(publicVars.cssId.sliderItemBoxImgCls, privateVars.sliderItemsMap[(currentFirst - 1)].element).attr('src', imgSrc);

                        preloader.preloadSingleImage('system', imgSrc, function() {
                        });

                    }

                }



            },
            startup: function() {

                /** added */
                publicVars.perSetItems = privateMethods.getCurrentPerSetItemsNumber();
                /** -- */

                privateVars.sliderCount = $(publicVars.cssId.sliderItemCls).length;
                privateVars.originalSliderCount = privateVars.sliderCount;

                privateVars.sliderCurrentItemLast = publicVars.perSetItems;

                $(publicVars.cssId.sliderItemCls).each(function(key, value) {

                    var cloned = $(this).clone(true, true);

                    if(publicVars.options && publicVars.options.stripHref == 1) {
                        cloned.removeAttr('href');
                    }

                    //cloned.removeClass(publicVars.cssId.sliderActiveCls.substr(1));

                    privateVars.sliderItemsMap[key] = {
                        element: cloned
                    };

                    if (publicVars.perSetItems < (key + 1)) {
                        $(this).remove();
                    }

                });

                $.extend(true, privateVars.originalSliderItemsMapHolder, privateVars.sliderItemsMap);

                privateMethods.calculateSliderSets();
                privateMethods.handleSliderArrows();

                privateMethods.preloadImages();

                container.msg(privateVars.name + ' - item count ' + privateVars.sliderCount);
                container.msg(privateVars.name + ' - item sets ' + privateVars.sliderSets);

                container.msg(privateVars.name + ' - first item ' + privateVars.sliderCurrentItemFirst + ' last item ' + privateVars.sliderCurrentItemLast);
            },
            bind: function() {
                container.msg(privateVars.name + ' - module started');

                //carousel arrow click
                $(publicVars.cssId.sliderArrowLeftId).click(function() {

                    if (privateVars.slide == 0 && privateVars.sliderSets > 1) {

                        if(publicVars.btnInactiveV1 == 1) {
                            if(privateVars.sliderCurrentSet == 1) {
                                return;
                            }
                        }

                        privateVars.slide = 1;

                        container.msg(privateVars.name + ' - left arrow clicked');

                        privateMethods.moveSlider('left');
                    }

                });

                //carousel arrow click
                $(publicVars.cssId.sliderArrowRightId).click(function() {

                    if (privateVars.slide == 0 && privateVars.sliderSets > 1) {
                        if(publicVars.btnInactiveV1 == 1) {
                            if(privateVars.sliderSets <= privateVars.sliderCurrentSet) {
                                return;
                            }
                        }

                        privateVars.slide = 1;

                        container.msg(privateVars.name + ' - right arrow clicked');

                        privateMethods.moveSlider('right');
                    }

                });

                $(publicVars.cssId.sliderFilterByBtnId).click(function() {
                    if (privateVars.filterFlag == 0) {
                        privateMethods.filter.show();
                    }
                });

                $(publicVars.cssId.sliderFilterByCloseId).click(function() {
                    privateMethods.filter.close();
                });

                $(publicVars.cssId.sliderFilterByCategoryCls).click(function() {
                    var type = container.getData($(this)[0], 'type');

                    privateMethods.filter.filterBy(type, $(this));
                });

                $('body').bind("click touchstart", function(event) {

                    if ($(event.target).closest(publicVars.cssId.sliderFilterByWrapperCls).length === 0) {
                        //privateMethods.handleMenuClose();
                        privateMethods.filter.close();
                    }

                });

                $(window).resize(function() {
                    privateMethods.recalculateSlider();
                });

                $(window).on("orientationchange", function() {
                    privateMethods.recalculateSlider();
                });
                /*
                 $(publicVars.cssId.sliderItemCls).click(function(e) {
                 //e.preventDefault();
                 //alert($(this).attr('href'));
                 if ($(this).attr('href') != '') {
                 privateVars.clickedHref = $(this).attr('href');
                 }
                 });
                 */

                /*$(publicVars.cssId.sliderWrapperId).mousedown(function(e) {
                 e.preventDefault();
                 return privateMethods.slideMouseDown(e);
                 });*/

                $(publicVars.cssId.sliderWrapperId).bind('touchstart', function(e) {
                    //e.preventDefault();
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return privateMethods.slideMouseDown(touch);
                });

                /*$(publicVars.cssId.sliderWrapperId).mousemove(function(e) {
                 e.preventDefault();
                 return privateMethods.slideMouseMove(e);
                 });*/

                $(publicVars.cssId.sliderWrapperId).bind('touchmove', function(e) {
                    /*if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                     e.preventDefault();
                     }*/
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return privateMethods.slideMouseMove(touch, e);
                });


                /*                $(publicVars.cssId.sliderWrapperId).mouseup(function(e) {
                 e.preventDefault();
                 return privateMethods.slideMouseUp(e);
                 });*/

                $(publicVars.cssId.sliderWrapperId).bind('touchend', function(e) {
                    //e.preventDefault();
                    var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                    return privateMethods.slideMouseUp(touch);
                });

            },

            slideMouseDown: function(e) {

                if (!privateVars.slideStarted && privateVars.slide == 0 && privateVars.sliderCount > publicVars.perSetItems)
                {
                    privateVars.touchStart = e.pageX;
                    privateVars.touchStartY = e.pageY;

                    privateVars.slideStarted = true;

                    var nextPrevValues = privateMethods.calculatePrevNextValues('left');
                    privateMethods.putProperData(nextPrevValues.next, nextPrevValues.nextFirstItem, nextPrevValues.nextLastItem);
                    var nextPrevValues = privateMethods.calculatePrevNextValues('right');
                    privateMethods.putProperData(nextPrevValues.next, nextPrevValues.nextFirstItem, nextPrevValues.nextLastItem);

                }

                //return false;

            },

            slideMouseMove: function(e, ev) {

                if (privateVars.slideStarted && !privateVars.endTrans && privateVars.slide == 0)
                {

                    var moveFactor = -($(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).outerWidth());

                    privateVars.touchDiff = privateVars.touchStart - e.pageX;
                    privateVars.touchDiffY = privateVars.touchStartY - e.pageY;
                    /*
                     if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                     ev.preventDefault();
                     }
                     */

                    if (privateVars.touchDiff < 0) {
                        if(publicVars.btnInactiveV1 == 1) {
                            if(privateVars.sliderCurrentSet == 1) {
                                return;
                            }
                        }

                        var nextPrevValues = privateMethods.calculatePrevNextValues('left');
                        //privateMethods.putProperData(nextPrevValues.next, nextPrevValues.nextFirstItem, nextPrevValues.nextLastItem);

                        $(publicVars.cssId.sliderSetId + nextPrevValues.next).css({translate: (moveFactor - privateVars.touchDiff) + 'px, 0', display: 'block'});
                        //$('#' + publicVars.cssId.sliderItem.substr(1) + nextId).css({left: (moveFactor - privateVars.touchDiff) + 'px', display: 'block'});
                    } else if (privateVars.touchDiff > 0) {

                        if(publicVars.btnInactiveV1 == 1) {
                            if(privateVars.sliderCurrentSet == privateVars.sliderSets) {
                                return;
                            }
                        }

                        var nextPrevValues = privateMethods.calculatePrevNextValues('right');
                        //privateMethods.putProperData(nextPrevValues.next, nextPrevValues.nextFirstItem, nextPrevValues.nextLastItem);

                        $(publicVars.cssId.sliderSetId + nextPrevValues.next).css({translate: (-(moveFactor) - privateVars.touchDiff) + 'px, 0', display: 'block'});
                        //$('#' + publicVars.cssId.sliderItem.substr(1) + nextId).css({left: (-(moveFactor) - privateVars.touchDiff) + 'px', display: 'block'});
                    }

                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).css({translate: -(privateVars.touchDiff) + 'px, 0'});
                    //$('#' + publicVars.cssId.sliderItem.substr(1) + privateVars.currentItem).css({left: -(privateVars.touchDiff) + 'px'});
                    if (Math.abs(privateVars.touchDiff) >= Math.abs(privateVars.touchDiffY)) {
                        ev.preventDefault();
                    }
                }

                //return false;
            },

            slideMouseUp: function(e) {

                if (privateVars.slideStarted && privateVars.slide == 0)
                {
                    privateVars.endTrans = true;

                    if (privateVars.touchDiff < -40) {

                        if(publicVars.btnInactiveV1 == 1) {
                            if(privateVars.sliderCurrentSet == 1) {
                                privateVars.slideStarted = false;
                                privateVars.endTrans = false;
                                return;
                            }
                        }

                        privateVars.slide = 1;

                        privateMethods.moveSlider('left');
                    } else if (privateVars.touchDiff > 40) {

                        if(publicVars.btnInactiveV1 == 1) {
                            if(privateVars.sliderCurrentSet == privateVars.sliderSets) {
                                privateVars.slideStarted = false;
                                privateVars.endTrans = false;
                                return;
                            }
                        }

                        privateVars.slide = 1;

                        privateMethods.moveSlider('right');
                    } else {
                        /*alert(privateVars.clickedHref);
                         if(privateVars.clickedHref != '') {
                         location.href = privateVars.clickedHref;
                         } */
                        privateVars.touchDiff = 0;
                        privateVars.touchStart = 0;

                        privateVars.touchDiffY = 0;
                        privateVars.touchStartY = 0;

                        $('.' + publicVars.cssId.sliderSetId.substr(1) + ':not(' + publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet + ')').html('');
                        $('.' + publicVars.cssId.sliderSetId.substr(1) + ':not(' + publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet + ')').removeAttr('style');

                        //privateMethods.putProperData(privateVars.sliderCurrentSet, privateVars.sliderCurrentItemFirst, privateVars.sliderCurrentItemLast);
                        $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).css({translate: '0, 0'});




                        privateVars.slideStarted = false;
                        privateVars.endTrans = false;
                    }
                } else {

                    privateVars.slideStarted = false;
                    privateVars.endTrans = false;
                }
            },

            filter: {
                show: function() {
                    $(publicVars.cssId.sliderFilterByLayerId).css({opacity: 0, display: 'block'});
                    $(publicVars.cssId.sliderFilterByLayerId).transit({opacity: 1}, 200);
                },
                close: function() {
                    $(publicVars.cssId.sliderFilterByLayerId).transit({opacity: 0}, 200, function() {
                        $(publicVars.cssId.sliderFilterByLayerId).css({opacity: 1, display: 'none'});
                    });
                },
                filterBy: function(type, handler) {
                    container.msg(privateVars.name + ' - filter by ' + type);

                    $(publicVars.cssId.sliderFilterByCategoryCls).removeClass(publicVars.cssId.sliderFilterIsActiveCls.substr(1));

                    handler.addClass(publicVars.cssId.sliderFilterIsActiveCls.substr(1));

                    privateMethods.filter.close();

                    privateMethods.filter.executeFilterBy(type);
                },

                executeFilterBy: function(type) {

                    privateVars.filterFlag = 1;

                    $(publicVars.cssId.sliderArrowLeftId).css({display: 'none'});
                    $(publicVars.cssId.sliderArrowRightId).css({display: 'none'});

                    $(publicVars.cssId.sliderFilterByBtnId).addClass(publicVars.cssId.sliderFilterIsInactiveCls.substr(1));

                    var newItemsMap = {};
                    var newItemsCount = 0;

                    if (type != 'all') {
                        for (var i = 0; i < privateVars.originalSliderCount; i++) {

                            if (container.getData(privateVars.originalSliderItemsMapHolder[i].element[0], 'type') == type) {
                                newItemsMap[newItemsCount] = privateVars.originalSliderItemsMapHolder[i];

                                newItemsCount++;
                            }

                        }
                    } else {
                        newItemsMap = privateVars.originalSliderItemsMapHolder;
                        newItemsCount = privateVars.originalSliderCount;
                    }

                    privateVars.sliderItemsMap = newItemsMap;

                    if ($(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).length === 0) {
                        var newSet = $(publicVars.cssId.sliderSetId + '1').clone();
                        newSet.attr('id', publicVars.cssId.sliderSetId.substr(1) + privateVars.sliderCurrentSet);
                        newSet.removeAttr('style');

                        $(publicVars.cssId.sliderWrapperId).append(newSet);
                    }

                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).transit({opacity: 0}, 300, function() {
                        $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).css({display: 'none', opacity: 1});

                        $(publicVars.cssId.sliderLoaderId).fadeIn(100, function() {

                            privateVars.sliderCount = newItemsCount;
                            privateVars.sliderCurrentItemFirst = 1;
                            privateVars.sliderCurrentItemLast = publicVars.perSetItems;

                            privateVars.sliderCurrentSet = 1;

                            privateMethods.calculateSliderSets();
                            privateMethods.handleSliderArrows();

                            privateMethods.preloadImages();

                            $('.' + publicVars.cssId.sliderSetId.substr(1)).html('');
                            $('.' + publicVars.cssId.sliderSetId.substr(1)).removeAttr('style');

                            privateMethods.calculateSliderSets();
                            privateMethods.handleSliderArrows();

                            privateMethods.preloadImages();

                            var imgTab = [];

                            for (var i = 0; i < publicVars.perSetItems; i++) {
                                if (privateVars.sliderItemsMap[i]) {
                                    var imgSrc = container.getData(privateVars.sliderItemsMap[i].element[0], 'img.src');

                                    $(publicVars.cssId.sliderItemBoxImgCls, privateVars.sliderItemsMap[i].element).attr('src', imgSrc);

                                    imgTab.push(imgSrc);

                                }
                            }

                            /** fix **/
                            if (newItemsCount > 0) {
                                privateMethods.putProperData(privateVars.sliderCurrentSet, privateVars.sliderCurrentItemFirst, privateVars.sliderCurrentItemLast);
                            }

                            preloader.setPreloadBulk('system-' + type, imgTab);

                            preloader.getPreloadBulkFinished('system-' + type, function() {

                                $(publicVars.cssId.sliderLoaderId).fadeOut(100, function() {
                                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).fadeIn(100);
                                    $(publicVars.cssId.sliderFilterByBtnId).removeClass(publicVars.cssId.sliderFilterIsInactiveCls.substr(1));
                                    privateVars.filterFlag = 0;
                                });
                            });


                        });
                    });
                }
            },

            calculateSliderSets: function() { 
                if (privateVars.sliderCount > 0) {
                    privateVars.sliderSets = Math.ceil(privateVars.sliderCount / publicVars.perSetItems);
                } else {
                    privateVars.sliderSets = 0;
                }
            },

            handleSliderArrows: function(currentSet) {

                currentSet = currentSet || privateVars.sliderCurrentSet;

                if (privateVars.sliderSets < 2) {
                    if(publicVars.btnInactiveV1 == 1) {
                        $(publicVars.cssId.sliderArrowLeftId).addClass(publicVars.cssId.sliderArrowInactiveCls.substr(1));
                        $(publicVars.cssId.sliderArrowRightId).addClass(publicVars.cssId.sliderArrowInactiveCls.substr(1));
                    } else if (publicVars.btnInactive == 1) {
                        $(publicVars.cssId.sliderArrowLeftId).removeClass(publicVars.cssId.sliderArrowStripCls.substr(1));
                        $(publicVars.cssId.sliderArrowRightId).removeClass(publicVars.cssId.sliderArrowStripCls.substr(1));
                    } else {
                        $(publicVars.cssId.sliderArrowLeftId).css({display: 'none'});
                        $(publicVars.cssId.sliderArrowRightId).css({display: 'none'});
                    }
                } else {
                    if(publicVars.btnInactiveV1 == 1) {

                        if(currentSet == 1) {
                            $(publicVars.cssId.sliderArrowLeftId).addClass(publicVars.cssId.sliderArrowInactiveCls.substr(1));
                        } else {
                            $(publicVars.cssId.sliderArrowLeftId).removeClass(publicVars.cssId.sliderArrowInactiveCls.substr(1));
                        }

                        if(currentSet == privateVars.sliderSets) {
                            $(publicVars.cssId.sliderArrowRightId).addClass(publicVars.cssId.sliderArrowInactiveCls.substr(1));
                        } else {
                            $(publicVars.cssId.sliderArrowRightId).removeClass(publicVars.cssId.sliderArrowInactiveCls.substr(1));
                        }
                    } else if (publicVars.btnInactive == 1) {
                        $(publicVars.cssId.sliderArrowLeftId).addClass(publicVars.cssId.sliderArrowStripCls.substr(1));
                        $(publicVars.cssId.sliderArrowRightId).addClass(publicVars.cssId.sliderArrowStripCls.substr(1));
                    } else {
                        $(publicVars.cssId.sliderArrowLeftId).css({display: 'block'});
                        $(publicVars.cssId.sliderArrowRightId).css({display: 'block'});
                    }
                }
            },

            getCurrentPerSetItemsNumber: function() {
                if (publicVars.perSetItemsTab.length > 0) {

                    var perSet = publicVars.perSetItems;

                    for (var i = 0; i < publicVars.perSetItemsTab.length; i++) {
                        if (Modernizr.mq('screen and (min-width: ' + publicVars.perSetItemsTab[i]['min'] + 'px) and (max-width: ' + publicVars.perSetItemsTab[i]['max'] + 'px)')) {
                            perSet = publicVars.perSetItemsTab[i]['perSet'];
                        }
                    }

                    return perSet;

                } else {
                    return publicVars.perSetItems;
                }
            },

            recalculateSlider: function() {

                var newNumberOfItems = privateMethods.getCurrentPerSetItemsNumber();

                if (publicVars.perSetItems != newNumberOfItems) {

                    var oldPerSetItems = publicVars.perSetItems;

                    publicVars.perSetItems = newNumberOfItems;

                    privateMethods.calculateSliderSets();

                    privateVars.sliderCurrentSet = Math.ceil(privateVars.sliderCurrentItemFirst / publicVars.perSetItems);

                    if ((privateVars.sliderCurrentItemFirst + publicVars.perSetItems - 1) <= privateVars.sliderCount) {
                        privateVars.sliderCurrentItemLast = privateVars.sliderCurrentItemFirst + publicVars.perSetItems - 1;
                    } else {

                        if (privateVars.sliderCount < publicVars.perSetItems) {
                            
                            if(privateVars.sliderCurrentItemFirst > 1) {
                                privateVars.sliderCurrentItemLast = privateVars.sliderCurrentItemFirst - 1;
                            } else {
                                privateVars.sliderCurrentItemLast = privateVars.sliderCount;
                            }
                            
                        } else {
                            //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                            privateVars.sliderCurrentItemLast = publicVars.perSetItems + privateVars.sliderCurrentItemFirst - privateVars.sliderCount - 1;
                        }
                    }

                    privateMethods.handleSliderArrows();

                    $('.' + publicVars.cssId.sliderSetId.substr(1)).html('');
                    $('.' + publicVars.cssId.sliderSetId.substr(1)).removeAttr('style');

                    privateMethods.putProperData(privateVars.sliderCurrentSet, privateVars.sliderCurrentItemFirst, privateVars.sliderCurrentItemLast);

                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).css({display: 'block'});

                    container.msg(privateVars.name + ' recalculate - first item ' + privateVars.sliderCurrentItemFirst + ' last item ' + privateVars.sliderCurrentItemLast);
                    container.msg(privateVars.name + ' recalculate - current set ' + privateVars.sliderCurrentSet);
                    container.msg(privateVars.name + ' recalculate - per set ' + publicVars.perSetItems);
                }
            },

            putProperData: function(next, nextFirstItem, nextLastItem) {
                /** added */

                if ($(publicVars.cssId.sliderSetId + next).length === 0) {
                    var newSet = $(publicVars.cssId.sliderSetId + '1').clone();
                    newSet.attr('id', publicVars.cssId.sliderSetId.substr(1) + next);
                    newSet.removeAttr('style');

                    $(publicVars.cssId.sliderWrapperId).append(newSet);
                }
                /** -- */

                $(publicVars.cssId.sliderSetId + next).html('');

                if (nextFirstItem > nextLastItem) {
                    for (var i = nextFirstItem; i <= privateVars.sliderCount; i++) {

                        if (privateVars.sliderItemsMap[(i - 1)]) {
                            if (typeof privateVars.elemDecorateCallback === 'function') {
                                privateVars.sliderItemsMap[(i - 1)].element = privateVars.elemDecorateCallback(privateVars.sliderItemsMap[(i - 1)].element);
                            }

                            privateVars.sliderItemsMap[(i - 1)].element.clone(true, true).appendTo($(publicVars.cssId.sliderSetId + next));
                        }
                    }

                    for (var i = 1; i <= nextLastItem; i++) {

                        if (privateVars.sliderItemsMap[(i - 1)]) {
                            if (typeof privateVars.elemDecorateCallback === 'function') {
                                privateVars.sliderItemsMap[(i - 1)].element = privateVars.elemDecorateCallback(privateVars.sliderItemsMap[(i - 1)].element);
                            }

                            privateVars.sliderItemsMap[(i - 1)].element.clone(true, true).appendTo($(publicVars.cssId.sliderSetId + next));
                        }
                    }
                } else {
                    for (var i = nextFirstItem; i <= nextLastItem; i++) {

                        if (privateVars.sliderItemsMap[(i - 1)]) {
                            if (typeof privateVars.elemDecorateCallback === 'function') {
                                privateVars.sliderItemsMap[(i - 1)].element = privateVars.elemDecorateCallback(privateVars.sliderItemsMap[(i - 1)].element);
                            }

                            privateVars.sliderItemsMap[(i - 1)].element.clone(true, true).appendTo($(publicVars.cssId.sliderSetId + next));
                        }
                    }
                }
            },

            calculatePrevNextValuesForSet: function (newSet) {
                var nextFirstItem = 1;
                var nextLastItem = publicVars.perSetItems;

                if(newSet > 1 && newSet <= privateVars.sliderSets) {
                    nextFirstItem = nextFirstItem + (newSet - 1) * publicVars.perSetItems;

                    nextLastItem = nextFirstItem + publicVars.perSetItems - 1;

                    if(nextLastItem > privateVars.sliderCount) {
                        nextLastItem = (nextLastItem - privateVars.sliderCount);
                    }
                }

                return {next: newSet, nextFirstItem: nextFirstItem, nextLastItem: nextLastItem }
            },

            calculatePrevNextValues: function(dir) {

                var nextFirstItem = 0;
                var nextLastItem = 0;

                if (dir == 'left') {
                    var next = (privateVars.sliderCurrentSet == 1) ? privateVars.sliderSets : privateVars.sliderCurrentSet - 1;
                    var signOut = '';
                    var signIn = '-';

                    if ((privateVars.sliderCurrentItemFirst - publicVars.perSetItems) > 0) {
                        nextFirstItem = privateVars.sliderCurrentItemFirst - publicVars.perSetItems;
                    } else {
                        //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                        nextFirstItem = privateVars.sliderCount - publicVars.perSetItems + privateVars.sliderCurrentItemFirst;
                    }

                    if ((privateVars.sliderCurrentItemLast - publicVars.perSetItems) > 0) {
                        nextLastItem = privateVars.sliderCurrentItemLast - publicVars.perSetItems;
                    } else {
                        nextLastItem = privateVars.sliderCount - publicVars.perSetItems + privateVars.sliderCurrentItemLast;
                    }


                } else {
                    var next = (privateVars.sliderCurrentSet == privateVars.sliderSets) ? 1 : privateVars.sliderCurrentSet + 1;
                    var signOut = '-';
                    var signIn = '';

                    if ((privateVars.sliderCurrentItemFirst + publicVars.perSetItems) <= privateVars.sliderCount) {
                        nextFirstItem = privateVars.sliderCurrentItemFirst + publicVars.perSetItems;
                    } else {
                        //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                        nextFirstItem = publicVars.perSetItems + privateVars.sliderCurrentItemFirst - privateVars.sliderCount;
                    }

                    if ((privateVars.sliderCurrentItemLast + publicVars.perSetItems) <= privateVars.sliderCount) {
                        nextLastItem = privateVars.sliderCurrentItemLast + publicVars.perSetItems;
                    } else {
                        //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                        nextLastItem = publicVars.perSetItems + privateVars.sliderCurrentItemLast - privateVars.sliderCount;
                    }
                }


                return {next: next, nextFirstItem: nextFirstItem, nextLastItem: nextLastItem, signIn: signIn, signOut: signOut}
            },

            moveSlider: function(dir) {

                privateMethods.recalculateSlider();

                var width = $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).outerWidth();

                var nextPrevValues = privateMethods.calculatePrevNextValues(dir);

                /*
                 var nextFirstItem = 0;
                 var nextLastItem = 0;
                 
                 if (dir == 'left') {
                 var next = (privateVars.sliderCurrentSet == 1) ? privateVars.sliderSets : privateVars.sliderCurrentSet - 1;
                 var signOut = '';
                 var signIn = '-';
                 
                 if ((privateVars.sliderCurrentItemFirst - publicVars.perSetItems) > 0) {
                 nextFirstItem = privateVars.sliderCurrentItemFirst - publicVars.perSetItems;
                 } else {
                 //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                 nextFirstItem = privateVars.sliderCount - publicVars.perSetItems + privateVars.sliderCurrentItemFirst;
                 }
                 
                 if ((privateVars.sliderCurrentItemLast - publicVars.perSetItems) > 0) {
                 nextLastItem = privateVars.sliderCurrentItemLast - publicVars.perSetItems;
                 } else {
                 nextLastItem = privateVars.sliderCount - publicVars.perSetItems + privateVars.sliderCurrentItemLast;
                 }
                 
                 
                 } else {
                 var next = (privateVars.sliderCurrentSet == privateVars.sliderSets) ? 1 : privateVars.sliderCurrentSet + 1;
                 var signOut = '-';
                 var signIn = '';
                 
                 if ((privateVars.sliderCurrentItemFirst + publicVars.perSetItems) <= privateVars.sliderCount) {
                 nextFirstItem = privateVars.sliderCurrentItemFirst + publicVars.perSetItems;
                 } else {
                 //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                 nextFirstItem = publicVars.perSetItems + privateVars.sliderCurrentItemFirst - privateVars.sliderCount;
                 }
                 
                 if ((privateVars.sliderCurrentItemLast + publicVars.perSetItems) <= privateVars.sliderCount) {
                 nextLastItem = privateVars.sliderCurrentItemLast + publicVars.perSetItems;
                 } else {
                 //var rest = privateVars.sliderCount - privateVars.sliderCurrentItemFirst;
                 nextLastItem = publicVars.perSetItems + privateVars.sliderCurrentItemLast - privateVars.sliderCount;
                 }
                 }
                 */

                privateVars.sliderCurrentItemFirst = nextPrevValues.nextFirstItem;
                privateVars.sliderCurrentItemLast = nextPrevValues.nextLastItem;

                privateMethods.preloadImages();

                container.msg(privateVars.name + ' - next first item ' + nextPrevValues.nextFirstItem);
                container.msg(privateVars.name + ' - next last item ' + nextPrevValues.nextLastItem);

                privateMethods.putProperData(nextPrevValues.next, nextPrevValues.nextFirstItem, nextPrevValues.nextLastItem);

                //$(publicVars.cssId.sliderSetId + next + ' ' + publicVars.cssId.sliderItemCls).removeClass('is-active'); 

                //$(publicVars.cssId.sliderSetId + next).append(privateVars.sliderItemsMap[(nextFirstItem - 1)].element);
                //privateVars.sliderItemsMap[(nextFirstItem - 1)].element.clone(true, true).appendTo($(publicVars.cssId.sliderSetId + next));
                //privateVars.sliderItemsMap[(nextLastItem - 1)].element.clone(true, true).appendTo($(publicVars.cssId.sliderSetId + next));
                //$(publicVars.cssId.sliderSetId + next).append(privateVars.sliderItemsMap[(nextLastItem - 1)].element);

                if(privateVars.callbacks && privateVars.callbacks.beforeSlide && typeof privateVars.callbacks.beforeSlide === 'function') {
                    privateVars.callbacks.beforeSlide($(publicVars.cssId.sliderItemCls, publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet));
                }

                $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).transit({translate: nextPrevValues.signOut + width + 'px, 0'}, 500);

                if(publicVars.btnInactiveV1 == 1) {
                    privateMethods.handleSliderArrows(nextPrevValues.next);
                }

                $(publicVars.cssId.sliderSetId + nextPrevValues.next).css({translate: nextPrevValues.signIn + width - privateVars.touchDiff + 'px, 0', display: 'block'});
                $(publicVars.cssId.sliderSetId + nextPrevValues.next).transit({translate: '0, 0'}, 500, function() {
                    
                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).html('');

                    if((privateVars.sliderCurrentSet + 1) <= privateVars.sliderSets && (privateVars.sliderCurrentSet + 1) !== nextPrevValues.next) {
                        $(publicVars.cssId.sliderSetId + (privateVars.sliderCurrentSet + 1)).html('');
                    } else if(1 !== nextPrevValues.next) {
                        $(publicVars.cssId.sliderSetId + 1).html('');
                    }

                    if((privateVars.sliderCurrentSet - 1) >= 1 && (privateVars.sliderCurrentSet - 1) !== nextPrevValues.next) {
                        $(publicVars.cssId.sliderSetId + (privateVars.sliderCurrentSet - 1)).html('');
                    } else if(privateVars.sliderSets !== nextPrevValues.next) {
                        $(publicVars.cssId.sliderSetId + privateVars.sliderSets).html('');
                    }

                    privateVars.slide = 0;
                    privateVars.sliderCurrentSet = nextPrevValues.next;
                    privateVars.slideStarted = false;
                    privateVars.endTrans = false;
                    privateVars.touchDiff = 0;
                    privateVars.touchStart = 0;

                    privateVars.touchDiffY = 0;
                    privateVars.touchStartY = 0;

                    container.msg(privateVars.name + ' - current set ' + privateVars.sliderCurrentSet);
                });

            },

            setCurrentSet: (newSet) => {

                if(privateVars.slide === 1) {
                    return;
                }

                privateMethods.recalculateSlider();

                privateVars.slide = 1;

                newSet = parseInt(newSet);

                if(publicVars.btnInactiveV1 !== 1) {
                    privateVars.slide = 0;
                    container.msg(privateVars.name + ' - error please configure method');
                    return;
                }

                if(privateVars.sliderCurrentSet === newSet) {
                    privateVars.slide = 0;
                    container.msg(privateVars.name + ' - current set already shown');
                    return;
                }

                if(privateVars.sliderSets < newSet) {
                    privateVars.slide = 0;
                    container.msg(privateVars.name + ' - there is no set for given: ' + newSet);
                    return;
                }

                const nextPrevValues = privateMethods.calculatePrevNextValuesForSet(newSet);

                privateVars.sliderCurrentItemFirst = nextPrevValues.nextFirstItem;
                privateVars.sliderCurrentItemLast = nextPrevValues.nextLastItem;

                privateMethods.preloadImages();

                container.msg(privateVars.name + ' - next first item ' + nextPrevValues.nextFirstItem);
                container.msg(privateVars.name + ' - next last item ' + nextPrevValues.nextLastItem);

                privateMethods.putProperData(nextPrevValues.next, nextPrevValues.nextFirstItem, nextPrevValues.nextLastItem);

                $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).transit({ opacity: 0}, 500, function () {
                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).css({ opacity: 1, display: 'none'});
                });

                if(publicVars.btnInactiveV1 == 1) {
                    privateMethods.handleSliderArrows(nextPrevValues.next);
                }

                $(publicVars.cssId.sliderSetId + nextPrevValues.next).removeAttr('style');
                $(publicVars.cssId.sliderSetId + nextPrevValues.next).css({ opacity: 0, display: 'block'});
                $(publicVars.cssId.sliderSetId + nextPrevValues.next).transit({opacity: 1}, 500, function() {

                    $(publicVars.cssId.sliderSetId + privateVars.sliderCurrentSet).html('');

                    privateVars.slide = 0;
                    privateVars.sliderCurrentSet = nextPrevValues.next;
                    privateVars.slideStarted = false;
                    privateVars.endTrans = false;
                    privateVars.touchDiff = 0;
                    privateVars.touchStart = 0;

                    privateVars.touchDiffY = 0;
                    privateVars.touchStartY = 0;

                    container.msg(privateVars.name + ' - current set ' + privateVars.sliderCurrentSet);
                });

                // if((privateVars.sliderCurrentSet + 1) === newSet) {
                //     privateMethods.moveSlider('right');
                // }
            }
        };

        var publicObj = {
            init: function(options) {
                privateMethods.prepareObj(options);
            },
            setElementDecorateCallback: function(callback) {
                privateVars.elemDecorateCallback = callback;
            },
            setCallback: function (type, callback) {
                privateVars.callbacks[type] = callback;
            },
            setCurrentSet: function (newSet) {
                privateMethods.setCurrentSet(newSet);
            }
        }


        return publicObj;
    };

    var factory = {
        objId: 0,
        /**
         * Get new preloader object
         * 
         * @returns preloader
         */
        create: function() {
            factory.objId++;

            var obj = slider(factory.objId);

            return obj;
        }
    };

    return {
        create: factory.create
    }

});

/*
 
 */
